import React, { useState } from "react";
import Confirmation from "../shared/Confirmation";
import { deleteUserProfile } from "../../firebase/users";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../firebase/AuthProvider";
import CurrentPassword from "./CurrentPassword";
import { Grid } from "@material-ui/core";
import Notification from "../shared/TemporaryNotification";
import Spinner from "../shared/Spinner";
import Button from "../shared/Button";
import { makeStyles } from "@material-ui/core/styles";
import { colors } from "../../theme";
import { Link as RouterLink } from "react-router-dom";
import { Link } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  submit: {
    margin: theme.spacing(3, 0, 2),
    width: "200px",
  },
  url: {
    color: colors.URL,
    fontWeight: 500,
  },
  signin: {
    textAlign: "center",
    marginTop: "25px"
  },
}));

type StatusType = "form" | "confirm" | "loading" | "notifyerror";

export default function Delete() {
  const { t } = useTranslation();
  const classes = useStyles();
  const { user } = useAuth();
  const [status, setStatus] = useState<StatusType>("form");
  const [password, setPassword] = useState<string>("");
  const [passwordError, setPasswordError] = useState<boolean>(false);

  function handlePasswordChange(password: string) {
    setPasswordError(false);
    setPassword(password);
  }

  async function openConfirmation() {
    if (password.length === 0) {
      setPasswordError(true);
      return;
    }

    setPasswordError(false);
    setStatus("confirm");
  }

  async function closeConfirmation() {
    setPassword("");
    setStatus("form");
  }

  async function deleteProfile(profileId: string, password: string) {
    setStatus("loading");
    const deleteUserData = {
      email: user?.email ? user.email : "",
      password,
      profileId,
    };

    const success = await deleteUserProfile(deleteUserData);

    setPassword("");

    if (!success) setStatus("notifyerror");

    // If the delete is successful, the user will be signed out automatically
    // by the onAuthStateChanged mechanism in AuthProvider.tsx.
    // However, sometimes warnings or errors occur, most likely because of
    // race conditions between signing out and fetching data and setting state elsewhere.
  }

  if (!user) return null;

  return (
    <Grid container item justify="center" alignItems="center" direction="column">
      <Spinner isVisible={status === "loading"} />

      {status === "notifyerror" && (
        <Notification
          message={t("deleteprofile.failed")}
          handleClose={() => setStatus("form")}
          timeoutInSeconds={5}
        />
      )}

      {status === "confirm" && (
        <Confirmation
          text={t("deleteprofile.confirmdelete")}
          handleConfirm={() => {
            deleteProfile(user.id, password);
          }}
          handleCancel={closeConfirmation}
        />
      )}

      <Grid item>
        <CurrentPassword
          password={password}
          handleChange={handlePasswordChange}
          error={passwordError}
        />
      </Grid>

      <Grid item>
        <Button onClick={openConfirmation} className={classes.submit}>
          {t("deleteprofile.delete")}
        </Button>
      </Grid>
      <Grid item className={classes.signin}>
        <Link component={RouterLink} to="/profile/edit" variant="body2"className={classes.url} >
          {t("deleteprofile.backtoprofile")}
        </Link>
      </Grid>
    </Grid>
  );
}
